import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { CommentsFrequencySettingDto } from '@/api/models/comments-frequency-setting.dto';
import { BaseApi } from '@/api/base-api';

export class FrequenciesApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/comments';

  public async getPerGameUserMinCommentInterval(): Promise<CommentsFrequencySettingDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/management/comments-frequency`,
      {}
    );
  }

  public async updatePerGameUserMinCommentInterval(
    data: CommentsFrequencySettingDto
  ): Promise<Record<string, any>> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PUT] /api/v1/game-comments/management/comments-frequency`,
      data
    );
  }
}
